import styles from './Pagination.module.scss';

interface PaginationProps {
  total: number;
  active: number;
  onPageChange: (index: number) => void;
}

export const Pagination = ({
  total,
  active,
  onPageChange,
}: PaginationProps) => {
  return (
    <div className={styles['pagination']}>
      {Array.from({ length: total }).map((_, index) => (
        <div
          key={index}
          className={`${styles['pagination__bullet']} ${active === index ? styles['pagination__bullet--active'] : ''}`}
          onClick={() => onPageChange(index)}
        >
          {index + 1}
        </div>
      ))}
    </div>
  );
};
